const $html = $('html');

export const CURRENT_LANG = $html.data('lang');
export const IS_EGON_VALIDATION = $html.data('egon-validation');
export const IS_EGON_VALIDATION__ZIP_BASED = $html.data('egon-zip-base');
export const IS_MOBILE = window.matchMedia('(max-width:760px)').matches;
export const IS_PRIVACY_PAGE = $html.data('controller') === 'PrivacyLoginController';
export const IS_VERIFALIA_VALIDATION = $html.data('verifalia-validation');
